
import { useState, forwardRef, useImperativeHandle } from 'react';
import { X } from 'lucide-react';

export interface FreeProxyPopupRef {
  openPopup: () => void;
  openForm: () => void;
}

const FreeProxyPopup = forwardRef<FreeProxyPopupRef>((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useImperativeHandle(ref, () => ({
    openPopup: () => {
      console.log('Opening popup');
      setIsVisible(true);
      setIsClosing(false);
    },
    openForm: () => {
      console.log('Opening form directly');
      setIsVisible(true);
      setIsClosing(false);
    }
  }));

  const handleClose = () => {
    console.log('Closing popup');
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm transition-opacity duration-300 flex items-center justify-center p-4 ${
        isClosing ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
      onClick={handleBackdropClick}
    >
      <div 
        className={`bg-white rounded-xl shadow-2xl border border-gray-200 w-full max-w-md transition-all duration-300 ${
          isClosing ? 'scale-95 opacity-0' : 'scale-100 opacity-100'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative p-6">
          <button
            onClick={handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
          >
            <X className="h-6 w-6" />
          </button>

          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Get Your Free Proxy
            </h2>
            <p className="text-gray-600 mb-6">
              Enter your email for a free proxy trial
            </p>
            
            <div className="w-full">
              <script async src="https://tally.so/widgets/embed.js"></script>
              <iframe
                src="https://tally.so/r/np6P7E"
                width="100%"
                height="400"
                frameBorder="0"
                marginHeight={0}
                marginWidth={0}
                title="Free Proxy Trial Form"
                className="rounded border-0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

FreeProxyPopup.displayName = 'FreeProxyPopup';

export default FreeProxyPopup;
